import { render, staticRenderFns } from "./detail-header.vue?vue&type=template&id=fd6fd354&scoped=true&"
import script from "./detail-header.vue?vue&type=script&lang=ts&"
export * from "./detail-header.vue?vue&type=script&lang=ts&"
import style0 from "./detail-header.vue?vue&type=style&index=0&id=fd6fd354&lang=scss&scoped=true&"
import style1 from "./detail-header.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6fd354",
  null
  
)

export default component.exports